import BlankCouponDownload from '@components/blank/BlankCouponDownload';
import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import PullToRefresh from '@components/PullToRefresh';
import styled from '@emotion/styled';

import DownloadAbleCoupon from './DownloadAbleCoupon';
import useDownloadAbleCoupons from './hooks/useDownloadAbleCoupons';
import CouponFilter from '../../components/CouponFilter';
import CouponItemSkeletons from '../../components/CouponItemSkeletons';

function DownloadCouponFragment() {
    const {
        coupons, fetchNextPage, isBlank, isFetching, refetch,
    } = useDownloadAbleCoupons();
    return (
        <PullToRefresh onRefresh={refetch}>
            <Column fullWidth>
                <CouponFilter tab='DOWNLOAD'/>
                <Container spacing={4} align='center' fullWidth>
                    {(isBlank && !isFetching) && (
                        <BlankCouponDownload/>
                    )}
                    {coupons?.map((coupon) => (
                        <DownloadAbleCoupon coupon={coupon}
                            key={coupon.eventId}/>
                    ))}
                    <InfinityScrollTrigger trigger={fetchNextPage} />
                    {isFetching && (
                        <CouponItemSkeletons count={coupons?.length ? 1 : 5} withAction/>
                    )}
                </Container>
            </Column>
        </PullToRefresh>
    );
}

const Container = styled(Column)`
    padding: 0 var(--spacing-4);
`;

export default DownloadCouponFragment;
